<template>
  <div v-if="value && item" class="inv-overlay" @click.self="$emit('input', false)">
    <div class="inv-modal inv-modal--md">
      <div class="inv-modal__header">
        <span>
          <span :style="{ color: typeHex(item.type) }">{{ typeGlyph(item.type) }}</span>
          {{ item.name }}
        </span>
        <button class="inv-modal__close" @click="$emit('input', false)">×</button>
      </div>
      <div class="inv-modal__body">
        <div class="inv-detail-grid">
          <div v-for="f in detailFields" :key="f.key" class="inv-detail-item">
            <div class="inv-detail-item__label">{{ f.label }}</div>
            <div class="inv-detail-item__value" :class="{ 'inv-detail-item__value--mono': f.mono }">
              {{ resolveDetail(item, f) }}
            </div>
          </div>
        </div>
        <div v-if="item.attachments && item.attachments.length" class="inv-detail-attachments">
          <div class="inv-detail-item__label">ATTACHMENTS</div>
          <div class="inv-detail-item__value">
            <div v-for="attachment in item.attachments" :key="attachment.id" class="inv-attachment">
              <span @click="openPublicFile(attachment)">{{ attachment.filename ?? attachment.name }}</span>
              <span @click="removeAttachment(item, attachment)" class="inv-attachment__remove">✕</span>
            </div>
          </div>
        </div>
        <div v-if="item.notes" class="inv-detail-notes">
          <div class="inv-detail-item__label">NOTES</div>
          <div class="inv-detail-item__value">{{ item.notes }}</div>
        </div>
      </div>
      <div class="inv-modal__footer">
        <button class="inv-btn inv-btn--ghost" @click="$emit('input', false)">Close</button>
        <button class="inv-btn inv-btn--primary" @click="$emit('edit')">EDIT</button>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service"
import Swal from "sweetalert2";
import { typeName, statusName, formatDate, typeHex, typeGlyph } from '../utils/tools.utils'



export const ENDPOINT = "humanResources/tools/"
export default {
  name: 'ToolsViewDialog',
  props: {
    value:        { type: Boolean, default: false },
    item:         { type: Object,  default: null },
    typeOptions:  { type: Array,   required: true },
    statusOptions:{ type: Array,   required: true },
  },
  data() {
    return {
      detailFields: [
        { key: 'serial_number',       label: 'SERIAL NUMBER',      mono: true },
        { key: 'model',               label: 'MODEL' },
        { key: 'type',                label: 'TYPE',               resolve: 'typeName' },
        { key: 'status',              label: 'STATUS',             resolve: 'statusName' },
        { key: 'purchase_date',       label: 'PURCHASE DATE',      resolve: 'formatDate' },
        { key: 'warranty_expires_at', label: 'WARRANTY EXPIRES AT',resolve: 'formatDate' },
        { key: 'touch_protection_date', label: 'TOUCH PROTECTION DATE',resolve: 'formatDate' },
        { key: 'created_at',          label: 'CREATED AT',         resolve: 'formatDate' },
        { key: 'updated_at',          label: 'UPDATED AT',         resolve: 'formatDate' },
        { key: 'user',          label: 'ATTACHED TO',         resolve: 'formatUser' },
      ],
    }
  },
  methods: {
    typeName, statusName, formatDate, typeHex, typeGlyph,
    /*typeName(v)   { return (this.typeOptions.find(o => o.value === v) || {}).text || '—' },
    statusName(v) { return (this.statusOptions.find(o => o.value === v) || {}).text || '—' },
    typeHex(v)    { return { 1: '#f59e0b', 2: '#3b82f6' }[v] || '#94a3b8' },
    typeGlyph(v)  { return { 1: '🔧', 2: '⚙️' }[v] || '◎' },
    formatDate(d) { if (!d) return '—'; return new Date(d).toLocaleDateString('hu-HU') },*/
    formatUser(d) { if (!d) return '—'; const name = [d.surname, d.christian_name1, d.christian_name2].filter(Boolean).join(' '); return `${name}`; },
    resolveDetail(item, f) {
      const v = item[f.key]
      if (!v && v !== 0) return '—'
      if (f.resolve === 'typeName')   return this.typeName(v)
      if (f.resolve === 'statusName') return this.statusName(v)
      if (f.resolve === 'formatDate') return this.formatDate(v)
      if (f.resolve === 'formatUser') return this.formatUser(v)
      return v
    },
    openPublicFile(file) {
      const base = process.env.VUE_APP_BACKEND_URL;
      let p = (file.path || "").replace(/^\/+/, "");
    
      window.open(`${base}/public/${p}`, "_blank");
    },
    removeAttachment(item, attachment) {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to delete this attachment?",
            confirmButtonColor: "#e33354",
            confirmButtonText: "Yes, delete it!",
            showCancelButton: true,
            cancelButtonText: "Cancel",
        }).then((result) => {            
            if (result.isConfirmed) {
                ApiService.delete(`${ENDPOINT}${item.id}/attachments/${attachment.id}`)
                    .then(() => {
                        this.$props.item.attachments = this.$props.item.attachments.filter(a => a.id !== attachment.id);
                        Swal.fire({
                            icon: "success",
                            title: "Attachment deleted successfully!",
                            timer: 1500,
                            showConfirmButton: false,
                        });
                    })
                    .catch(() => {
                        Swal.fire({
                            icon: "error",
                            title: "Failed to delete attachment.",
                            timer: 1500,
                            showConfirmButton: false,
                        });
                    });
            }
        });
    },
  },
}
</script>

<style scoped>
.inv-attachment{
    --danger2: #ff0000;
}
.inv-overlay {
  position: fixed; inset: 0; z-index: 999;
  background: rgba(0,0,0,0.35);
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(2px);
}
.inv-modal {
  background: var(--bg2); border: 1px solid var(--border2);
  box-shadow: 0 24px 64px rgba(0,0,0,0.15);
  display: flex; flex-direction: column; max-height: 90vh; overflow: hidden;
}
.inv-modal--md { width: 560px; }
.inv-modal__header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; border-bottom: 1px solid var(--border);
  font-family: 'IBM Plex Mono', monospace; font-size: 16px; font-weight: 700;
  letter-spacing: 0.08em; color: var(--text-bright); background: var(--bg3);
}
.inv-modal__close { background: none; border: none; color: var(--text-dim); font-size: 23px; cursor: pointer; line-height: 1; padding: 0 4px; }
.inv-modal__close:hover { color: var(--text); }
.inv-modal__body  { padding: 24px 20px; overflow-y: auto; flex: 1; }
.inv-modal__footer { padding: 14px 20px; border-top: 1px solid var(--border); display: flex; justify-content: flex-end; gap: 10px; background: var(--bg3); }

.inv-detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.inv-detail-notes, .inv-detail-attachments { margin-top: 16px; padding-top: 16px; border-top: 1px solid var(--border); }
.inv-detail-item__label { font-family: 'IBM Plex Mono', monospace; font-size: 12px; font-weight: 700; letter-spacing: 0.14em; color: var(--text-dim); margin-bottom: 4px; }
.inv-detail-item__value { font-size: 16px; color: var(--text-bright); }
.inv-detail-item__value--mono { font-family: 'IBM Plex Mono', monospace; font-size: 15px; color: var(--accent2); }
.inv-attachment span { color: var(--accent); text-decoration: none; cursor: pointer; }
.inv-attachment span:hover { text-decoration: underline; }
.inv-attachment__remove { margin-left: 8px; color: var(--danger); cursor: pointer; }
.inv-attachment__remove:hover { color: var(--danger2); }
.inv-attachment { display: flex; justify-content: space-between; align-items: center; gap: 4px; margin-bottom: 6px; }

.inv-btn { font-family: 'IBM Plex Mono', monospace; font-size: 14px; font-weight: 600; letter-spacing: 0.1em; padding: 8px 18px; border: 1px solid; cursor: pointer; transition: all 0.15s; display: inline-flex; align-items: center; gap: 6px; }
.inv-btn--primary { background: var(--accent); border-color: var(--accent); color: #fff; }
.inv-btn--primary:hover { background: var(--accent2); border-color: var(--accent2); }
.inv-btn--ghost   { background: transparent; border-color: var(--border2); color: var(--text); }
.inv-btn--ghost:hover { border-color: var(--text-dim); }

/* ── RESPONSIVE ── */
@media (max-width: 620px) {
  .inv-modal--md {
    width: 100%;
    max-width: 100%;
    max-height: 100vh;
    align-self: flex-end;
    border-left: none;
    border-right: none;
    border-bottom: none;
  }
  .inv-detail-grid { grid-template-columns: 1fr; }
  .inv-modal__body { padding: 16px 14px; }
  .inv-modal__header { font-size: 14px; padding: 14px 16px; }
  .inv-modal__footer { padding: 12px 14px; }
  .inv-detail-item__label { font-size: 11px; }
  .inv-detail-item__value { font-size: 14px; }
}

@media (max-width: 480px) {
  .inv-btn { font-size: 13px; padding: 8px 14px; }
}
</style>